import { AutoShipUnitOfMeasure } from '../types';
import type { ProductPromotion } from '../types';

export const getFrequencyInWeeks = (frequency: number, unitOfMeasure: AutoShipUnitOfMeasure): number => {
    switch (unitOfMeasure) {
        case AutoShipUnitOfMeasure.Days:
            return Math.ceil(frequency / 7);
        case AutoShipUnitOfMeasure.Months:
            return frequency * 4;
        default:
            return frequency; // default to number of weeks
    }
};

export const getUomByValue = (numericUnitOfMeasure: number): AutoShipUnitOfMeasure => {
    switch (numericUnitOfMeasure) {
        case 1:
            return AutoShipUnitOfMeasure.Days;
        case 3:
            return AutoShipUnitOfMeasure.Months;
        default:
            return AutoShipUnitOfMeasure.Weeks;
    }
};

export const GetAutoshipPromo = (promotions: ProductPromotion[]) =>
    promotions?.filter(promo => promo.isAutoShipPromotion)?.[0];
